/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Xrisk_ContentInputs */

const en_home_xrisk_content = /** @type {(inputs: Home_Xrisk_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Many AI labs and experts agree: AI could end humanity.`)
};

/**
* | output |
* | --- |
* | "Many AI labs and experts agree: AI could end humanity." |
*
* @param {Home_Xrisk_ContentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_xrisk_content = /** @type {((inputs?: Home_Xrisk_ContentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Xrisk_ContentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_xrisk_content(inputs)
});